import ShipperOrderTable from './component';

export default ShipperOrderTable;
